import { proxyLinksRewriter } from 'managers/proxyLinksRewriter';

export function proxyLinkIfNeeded(link: string) {
    if (settings.proxyTaskResources)
        return proxyLinksRewriter.rewriteURL(link);

    return link;
}